import React, { useState, useEffect, useContext, useRef } from 'react';
import { TableFilterRow } from '@devexpress/dx-react-grid-bootstrap4';
import Select from 'react-select';

import { DataContext as EmployeeTableContext } from '../../../stores/emp-table-store';
import { DataContext } from '../../../store';

import CustomSelect from '../shared/CustomSelect';
import { useTranslation } from 'react-i18next';
import { EMP_IS_WORKING, EMP_HAS_QUIT, EMP_WILL_START, SHOW_ALL } from '../../../i18n/keyConstants';

import { HandleStatusOptions, HandleCustomOptions, InputDebouncer } from '../shared/FilterEventHelpers';
import { translateOptionLabel } from '../../exl/shared/translations';

const FilterCell = ({ column, children, ...restProps }) => {
    const {
        store: { offices },
    } = useContext(DataContext);

    const {
        store: { selectedOffice, selectedRole, selectedStatus, selectedFilters, isResettingFilters, filters },
        dispatch,
    } = useContext(EmployeeTableContext);

    const columnName = column.name;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [chosenValue, setChosenValue] = useState(selectedFilters[columnName]);
    const intervalRef = useRef(null);

    const { t } = useTranslation(['shared']);


    useEffect(() => {
        if (IsTextInputColumn()) {
            if (!(chosenValue === selectedFilters[columnName])) {
                return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenValue]);

    useEffect(() => {
        if (IsTextInputColumn()) {
            return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch);         
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children[0].props.value]);

    useEffect(() => {
        if (isResettingFilters) {
            setChosenValue('');
            dispatch({ type: 'SELECTED_FILTERS_AND_FILTERS_RESET', columnName, payload: '' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResettingFilters]);

    const IsTextInputColumn = () => {
        return (columnName !== 'role' && columnName !== 'status' && columnName !== 'office');
    }

    const handleSelectValueChange = (selected) => {
        if (columnName === 'role') { dispatch({ type: 'SELECTED_ROLE', payload: selected })}
        else if (columnName === 'office') { dispatch({ type: 'SELECTED_OFFICE', payload: selected })}
    }

    if (columnName === 'status') {
        return (
            <th>
                <Select
                    isClearable={false}
                    isMulti
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={translateOptionLabel(selectedStatus, t)}
                    options={[
                        { label: t(EMP_IS_WORKING), value: 'isWorking' },
                        { label: t(EMP_WILL_START), value: 'willStart' },
                        { label: t(EMP_HAS_QUIT), value: 'hasQuit' },
                        { label: t(SHOW_ALL), value: 'showAll' },
                    ]}
                    onChange={(e) => {
                        HandleStatusOptions(e, filters, selectedStatus, handleSelectValueChange, dispatch);
                    }}
                />
            </th>
        );
    }
    if (columnName === 'office') {
        return (
            <CustomSelect
                {...restProps}
                columnName='office'
                options={offices && offices.map((option) => ({ value: option.name, label: option.name }))}
                selected={selectedOffice}
                onSelectedChange={(selected) => HandleCustomOptions(selected, filters, 'office', handleSelectValueChange, dispatch)}
            />
        );
    }
    if (columnName === 'role') {
        return (
            <CustomSelect
                {...restProps}
                columnName='role'
                options={[
                    { label: 'Admin', value: 'admin' },
                    { label: 'Consultant', value: 'consultant' },
                    { label: 'Ekonomi', value: 'ekonomi' },
                    { label: 'HR', value: 'hr' },
                    { label: 'PR', value: 'pr' },
                    { label: 'Sales', value: 'sales' },
                    { label: 'Studamb.', value: 'studamb.' },
                ]}
                selected={selectedRole}
                onSelectedChange={(selected) => HandleCustomOptions(selected, filters, 'role', handleSelectValueChange, dispatch)}
            />
        );
    }

    var FilterOptions = children[0];
    var TextInput = React.cloneElement(children[1], {
        value: chosenValue,
        onChange: (event) => {
            setChosenValue(event);
            children[1].props.onChange();
        }
    });

    return (
        <TableFilterRow.Cell
            column={column}
            {...restProps}>
            {FilterOptions}
            {TextInput}
        </TableFilterRow.Cell>
    );
}

export default FilterCell;
